import React, { useState } from "react";
import NACell from "../Reusable/DataTable/NACell";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/EndPoint";
import moment from "moment";
import Modal from "../Reusable/NoticeModal";
import NoticePopup from "./NoticePopup";

const NoticeList = () => {
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [noticeData, setNoticeData] = useState<any>(null);
  const defaultColumns = [
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <p>{moment(row?.oiriginal?.created).format("YY-MM-DD HH:mm:ss")}</p>
        );
      },
    },
    {
      header: "Title",
      accessorKey: "title",
      cell: NACell,
    },
    {
      header: "Type",
      accessorKey: "type",
      cell: NACell,
    },
    {
      header: "Start Date",
      accessorKey: "start_date",
      cell: NACell,
    },
    {
      header: "Expiry Date",
      accessorKey: "expiry_date",
      cell: NACell,
    },
  ];
  const handleRow = (row: any) => {
    const data = row?.original;
    if (data?.type === "popup") {
      setIsOpenPopup(!isOpenPopup);
    } else {
      alert(`${data?.title}-${data?.content}`);
    }
    setNoticeData(data);
  };

  return (
    <>
      <DataTable
        url={APIS.NOTICE}
        queryKey={"notice"}
        tableName={"Notice"}
        columns={defaultColumns}
        handleRow={handleRow}
      />
      <Modal title={"Notice"} isOpen={isOpenPopup} setIsOpen={setIsOpenPopup}>
        <NoticePopup NoticeData={noticeData} />
      </Modal>
    </>
  );
};

export default NoticeList;
